import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Icon, IconButton, Modal, Row, Table, Uploader, Whisper } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'
import { Controller, useForm } from 'react-hook-form'
import AlertWidget from '../../confirm/AlertWidget'
import { isImageOrPdf } from '../../../utils/ValidatorUtils'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { doneLoading, startLoading } from '../../../utils/loading'
import {
  callAuditReportSummary,
  saveAuditNotification,
} from '../../../redux/actions/auditReportSummary'
import notification from '../../../utils/notification'
import { isEmpty } from 'lodash-es'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AuditReportSummaryTable({
  schema,
  onSelect = () => {},
  onShow = () => {},
  loading,
  onExport = () => {},
  pagination,
  onReload = () => {},
  onSubmit = () => {},
  onTest = () => {},
  onExportWordFile = () => {},
  onSaveFiles = () => {},
  onExportFileIAp12 = () => {},
  onDelete = () => {},
  ...props
}) {
  // const [formSchema, setFormSchema] = useState(props.schema)
  // const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const [tableData, setTableData] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [isShowReqRegisterModal, setIsShowReqRegisterModal] = useState(false)
  const [requestRegisterNote, setRequestRegisterNote] = useState()
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowUploaderModal, setIsShowUploaderModal] = useState(false)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [rowDatas, setRowDatas] = useState()

  useEffect(() => {
    if (schema?.result?.values?.length > 0) {
      setTableData(schema?.result?.values)
    } else {
      setTableData([])
    }
  }, [schema])

  const defaultPage = 1

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(1, dataKey)
    }
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage', dataKey)
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, displayLength)
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleCheckAll = (value, checked) => {
    let newArr = []
    if (checked) {
      tableData.map((item) => {
        if (item.enableSendCoodinator && schema?.auditRole?.isInternalAuditor) {
          newArr.push(item.id)
        }
      })
    }

    setCheckedKeys(newArr)
    setCountSelected(newArr.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    if (schema?.auditRole?.isInternalAuditor && !rowData.enableSendCoodinator) {
      return (
        <Cell {...props} style={{ padding: 0 }}>
          <Checkbox inline disabled />
          {(page - 1) * displayLength + props.rowIndex + 1}
        </Cell>
      )
    }

    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
          />
          {(page - 1) * displayLength + props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await callAuditReportSummary(1, 25)
      // setSchema(response.model)
      setTableData(response.model?.result?.values)

      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleRequestRegisterAsset = () => {
    const request = {
      ids: checkedKeys,
      // note: requestRegisterNote,
    }

    // console.log('request => ', request)

    handleSaveRequestRegister(request)
  }

  const handleRequestBeforeRegisterAsset = () => {
    // if (checkedKeys.length == 0) {
    if (countSelected == 0) {
      setIsShowModalHelper(true)
    } else {
      setIsShowReqRegisterModal(true)
    }
  }

  const handleSaveRequestRegister = async (request) => {
    setIsLoading(true)
    startLoading()
    console.log('request===>', request)

    try {
      let response = await saveAuditNotification(request)
      console.log('response===>', request)
      if (response) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
        })
        handleGetSchema()

        setIsShowReqRegisterModal(false)
        setRequestRegisterNote('')
        setCountSelected(0)
        setCheckedKeys([])
      } else {
        setIsLoading(false)
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const Overlay = React.forwardRef(({ style, rowData, ...rest }, ref) => {
    // const close = () => triggerRef.current.close();
    // console.log('rowData => ', rowData)

    const styles = {
      ...style,
      background: '#fff',
      width: 250,
      padding: 10,
      borderRadius: 4,
      position: 'absolute',
      border: '1px solid #ddd',
      boxShadow: '0 3px 6px -2px rgba(0, 0, 0, 0.6)',
      textAlign: 'center',
      zIndex: 999,
    }

    return (
      <div {...rest} style={styles} ref={ref}>
        {/* <p style={{ fontWeight: 'bold' }}> {rowData?.projectCode || ''} </p>
        <hr style={{ marginTop: '10px', marginBottom: '10px' }} /> */}
        {(schema?.auditRole?.isInternalAuditor ||
          schema?.auditRole?.isAuditor ||
          schema?.auditRole?.isAuditor2 ||
          schema?.auditRole?.isCoordinator ||
          schema?.auditRole?.isUser) &&
          !rowData.disabled && (
            <IconButton
              appearance="ghost"
              icon={<Icon icon="save" className="bt-gost-icon-radius" />}
              onClick={() => {
                onSelect(rowData)
              }}
              size="sm"
              block
            >
              บันทึกผล
            </IconButton>
          )}

        <IconButton
          appearance="ghost"
          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
          onClick={() => {
            onShow(rowData)
          }}
          size="sm"
          block
        >
          แสดง
        </IconButton>

        {/* <hr style={{ marginTop: '10px', marginBottom: '10px' }} />

        <p style={{ color: '#848687', fontWeight: 'bold' }}>IAp12</p> */}

        {!rowData.uploadStatusIAp12 && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="upload2" className="bt-gost-icon-radius" />}
            // disabled={rowData.filePathIAp12}
            disabled={rowData.uploadStatusIAp12}
            onClick={() => {
              // onExportWordFile(rowData)
              setRowDatas(rowData)
              setIsShowUploaderModal(true)
            }}
            size="sm"
            block
          >
            อัพโหลด IAp12
          </IconButton>
        )}

        <IconButton
          appearance="ghost"
          disabled={!rowData.filePathIAp12}
          icon={
            <Icon
              icon="file-pdf-o" //"file-word-o"
              className="bt-gost-icon-radius"
            />
          }
          onClick={() => {
            onExportFileIAp12(rowData, 'download')
          }}
          size="sm"
          block
        >
          ดาวน์โหลด IAp12
        </IconButton>
        {/* <IconButton
          appearance="ghost"
          disabled={!rowData.filePathIAp12}
          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
          onClick={() => {
            onExportFileIAp12(rowData, 'view')
          }}
          size="sm"
          block
        >
          ดู IAp12
        </IconButton> */}

        {/* <hr style={{ marginTop: '10px', marginBottom: '10px' }} />
        <p style={{ color: '#848687', fontWeight: 'bold' }}>IAp10</p> */}

        <IconButton
          appearance="ghost"
          icon={<Icon icon="file-word-o" className="bt-gost-icon-radius" />}
          onClick={() => {
            onExportWordFile(rowData)
          }}
          size="sm"
          block
        >
          ดาวน์โหลด IAp10 (Word)
        </IconButton>
        <IconButton
          appearance="ghost"
          icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
          onClick={() => {
            onExport(rowData)
          }}
          size="sm"
          block
        >
          ดาวน์โหลด IAp10 (PDF)
        </IconButton>
        {rowData?.enableDelete && (
          <CancelButton
            appearance="ghost"
            //icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            //disabled={!rowData.enableDelete}
            icon={'trash'}
            onClick={() => {
              onDelete(rowData)
            }}
            size="sm"
            block
          >
            ลบรายการ
          </CancelButton>
        )}
      </div>
    )
  })

  const onSubmitFiles = async (data) => {
    // console.log('onSubmitFiles ', data)
    if (isEmpty(data.file)) {
      notification.open('error', {
        title: 'กรุณาแนบไฟล์ IAp12',
        duration: 5000,
      })
    } else {
      const x = await onSaveFiles(data.file, rowDatas.id)

      // console.log('x => ', x)

      x && setIsShowUploaderModal(false)
    }
  }

  return (
    <>
      <Table
        wordWrap
        height={800}
        headerHeight={80}
        data={tableData}
        loading={props.loading}
        style={{ marginTop: 20 }}
      >
        <Column
          // width={
          //   schema?.auditRole?.isInternalAuditor ||
          //   schema?.auditRole?.isAuditor ||
          //   schema?.auditRole?.isAuditor2
          //     ? 320
          //     : 220
          // }
          width={100}
          align="center"
          fixed
        >
          <HeaderCell>#</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <Whisper
                  trigger="focus"
                  placement="bottom"
                  // trigger="hover"
                  speaker={(props, ref) => {
                    const { className, left, top } = props
                    return (
                      <Overlay
                        style={{ left, top }}
                        className={className}
                        ref={ref}
                        rowData={rowData}
                      />
                    )
                  }}
                >
                  <Button appearance="ghost">จัดการ</Button>
                </Whisper>
              )
            }}
          </Cell>
        </Column>
        {schema?.auditRole?.isAuditor2 || schema?.auditRole?.isInternalAuditor ? (
          <Column width={110} align="center" fixed>
            <HeaderCell style={{ padding: 0 }}>
              <div style={{ lineHeight: '40px' }}>
                <Controller
                  name="chkRow"
                  control={control}
                  render={(props) => {
                    // if (isEditMode) {
                    //   return 'ลำดับ'
                    // }
                    return (
                      <Checkbox
                        inline
                        checked={props.value}
                        indeterminate={indeterminate}
                        onChange={(e, checked) => {
                          props.onChange(checked)
                          handleCheckAll(null, checked)
                        }}
                      >
                        <b>ลำดับ</b>
                      </Checkbox>
                    )
                  }}
                />
              </div>
            </HeaderCell>

            <CheckCell
              dataKey="id"
              checkedKeys={checkedKeys}
              onChange={(value, checked) => {
                handleCheck(value, checked)
              }}
            />
          </Column>
        ) : (
          <Column width={90} align="center" fixed>
            <HeaderCell>ลำดับ</HeaderCell>

            <Cell>
              {(_, index) => {
                return (page - 1) * displayLength + index + 1
              }}
            </Cell>
          </Column>
        )}

        <Column width={300} align="center">
          <HeaderCell>สถานะ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <div style={{ textAlign: 'left' }}>
                  <div>{rowData.status}</div>
                  {rowData.stepName && (
                    <div style={{ fontSize: '0.8rem', color: '#EEB189' }}>({rowData.stepName})</div>
                  )}
                </div>
              )
            }}
          </Cell>
          {/* <Cell dataKey="status" style={{ textAlign: 'left' }} /> */}
        </Column>
        <Column width={120} align="center">
          <HeaderCell>ปีงบประมาณตามแผน IA</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>
        <Column width={120} align="center">
          <HeaderCell>เลขที่สัญญา</HeaderCell>
          <Cell dataKey="contractNumber" />
        </Column>
        <Column width={120} align="center">
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={400}>
          <HeaderCell align="center">ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>
        <Column width={150} align="center">
          <HeaderCell>งบอนุมัติ</HeaderCell>
          {/* <Cell dataKey="approvedBudget" /> */}
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.approvedBudget)
            }}
          </Cell>
        </Column>
        <Column width={180}>
          <HeaderCell align="center">องค์กรรับทุน</HeaderCell>
          <Cell dataKey="fundedOrganization" />
        </Column>
        <Column width={180}>
          <HeaderCell align="center">ผู้รับทุน</HeaderCell>
          <Cell dataKey="grantee" />
        </Column>
        <Column width={180}>
          <HeaderCell align="center">ผู้รับผิดชอบโครงการ</HeaderCell>
          <Cell dataKey="responsibler" />
        </Column>
        <Column width={100}>
          <HeaderCell align="center">สำนัก</HeaderCell>
          <Cell dataKey="department" />
        </Column>
        <Column width={180}>
          <HeaderCell align="center">นักวิชาการ</HeaderCell>
          <Cell dataKey="scholar" />
        </Column>
        <Column width={150}>
          <HeaderCell align="center">ทีมตรวจ</HeaderCell>
          <Cell dataKey="inspectionTeam" />
        </Column>
        <Column width={80} align="center">
          <HeaderCell>เกรด</HeaderCell>
          <Cell dataKey="grade" />
        </Column>
      </Table>

      <TablePagination
        lengthMenu={[
          {
            label: 25,
            value: 25,
          },
          {
            label: 50,
            value: 50,
          },
          {
            label: 100,
            value: 100,
          },
          {
            label: 200,
            value: 200,
          },
          {
            label: 400,
            value: 400,
          },
        ]}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 25}
        total={schema?.result?.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      {schema?.auditRole?.isInternalAuditorLeader && (
        <Row style={{ marginTop: 20, textAlign: 'end' }}>
          <IconButton
            appearance="ghost"
            // style={{ marginRight: 15 }}
            icon={<Icon icon="send" className="bt-gost-icon-radius" />}
            onClick={(e) => {
              handleRequestBeforeRegisterAsset(checkedKeys)
            }}
          >
            {`ส่งให้นักวิชาการ (${countSelected} รายการ)`}
          </IconButton>
        </Row>
      )}

      {schema?.auditRole?.isAuditor2 == true && (
        <Row style={{ marginTop: 20, textAlign: 'end' }}>
          <IconButton
            appearance="ghost"
            // style={{ marginRight: 15 }}
            icon={<Icon icon="send" className="bt-gost-icon-radius" />}
            onClick={(e) => {
              handleRequestBeforeRegisterAsset(checkedKeys)
            }}
          >
            {`แจ้งผลการตรวจสอบ (${countSelected} รายการ)`}
          </IconButton>
        </Row>
      )}

      {/* Modal ขอขึ้นทะเบียน */}
      <Modal
        show={isShowReqRegisterModal}
        size="sm"
        onHide={(e) => {
          setIsShowReqRegisterModal(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          ทุกโครงที่เลือกไว้จะถูกส่งให้ นักวิชาการสำนักเพื่อบันทึกติดตามผลการตรวจสอบ
        </Modal.Body>
        <Modal.Footer>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="send-o" className="bt-gost-icon-radius" />}
            onClick={(e) => {
              handleRequestRegisterAsset()
            }}
          >
            ตกลง
          </IconButton>
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
            onClick={(e) => {
              setIsShowReqRegisterModal(false)
            }}
          >
            ยกเลิก
          </IconButton>
        </Modal.Footer>
      </Modal>

      <AlertWidget
        size="sm"
        title={globalMsgUtil.WARN_SELECTED_ITEM_TITLE}
        show={isShowModalHelper}
        detail={globalMsgUtil.WARN_SELECTED_ITEM_AUDIT}
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />

      {/* Upload IAp12 */}
      <Modal
        show={isShowUploaderModal}
        onHide={() => {
          setIsShowUploaderModal(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>อัปโหลดเอกสาร IAp12</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: 20 }}>
            <Controller
              // key={schema.attachFiles.name}
              name={'file'}
              control={control}
              // rules={isValidators(schema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={'.pdf'}
                    autoUpload={false}
                    // disabled={schema.attachFiles.disabled}
                    fileListVisible={true}
                    listType="text"
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          let file = fileList[fileList.length - 1]

                          if (isImageOrPdf(file.blobFile.type)) {
                            let newArr = []
                            newArr.push(file)

                            props.onChange(newArr)
                            setFileTypeError(false)
                          } else {
                            setFileTypeError(true)
                            notification.open('error', {
                              title: 'ชนิดที่รองรับ .pdf',
                              duration: 5000,
                            })
                          }
                        }
                      }
                    }}
                    draggable
                  >
                    <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div>
                  </Uploader>
                )
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="upload2" className="bt-gost-icon-radius" />}
            onClick={handleSubmit(onSubmitFiles)}
          >
            อัปโหลด
          </IconButton>
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
            onClick={(e) => {
              setIsShowUploaderModal(false)
            }}
          >
            ยกเลิก
          </IconButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}
